import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom Field Advice specific variables
 */
export const parseFieldAdviceEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Field Advice specific variables
  return {
    ...baseEnvironment,
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    PROPRIETARY_FERTILIZER_URL: config.PROPRIETARY_FERTILIZER_URL || '',
    FIELD_PLAN_URL: config.FIELD_PLAN_URL || '',
    ORDERPLANNING_URL: config.ORDERPLANNING_URL || '',
    GRASSLAND_CROP_ID: config.GRASSLAND_CROP_ID ? Number.parseInt(config.GRASSLAND_CROP_ID, 10) : 0,
    SHOW_GMB_WITH_EIP_REPORT: config.SHOW_GMB_WITH_EIP_REPORT === 'true',
    SHOW_POTATO_CROP_FIELDS_BUTTON: config.SHOW_POTATO_CROP_FIELDS_BUTTON === 'true',
    USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES:
      config.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES === 'true',
    USE_ARABLE_SERVICE_PLANET_PROOF_REPORT:
      config.USE_ARABLE_SERVICE_PLANET_PROOF_REPORT === 'true',
    PRE_SALES_REBUILD_DONE: config.PRE_SALES_REBUILD_DONE === 'true',
    FIELD_ADVICE_TEMPLATE_REBUILD_DONE: config.FIELD_ADVICE_TEMPLATE_REBUILD_DONE === 'true',
    FIELD_ADVICE_REBUILD_DONE: config.FIELD_ADVICE_REBUILD_DONE === 'true',
  };
};
